import ArrowBack from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { Box } from '@mui/material';
import * as Preact from 'preact';
export var Component = function (p) {
    return (Preact.h(Box, { sx: {
            boxSizing: 'border-box',
            height: '44px',
            width: '100%',
            display: 'flex',
            padding: '8px',
            justifyContent: 'space-between',
            alignItems: 'center',
        } },
        Preact.h(IconButton, { onClick: p.onBackArrowClick, size: "small", color: "secondary" },
            Preact.h(ArrowBack, { fontSize: "small" })),
        Preact.h(IconButton, { onClick: p.onCloseClick, size: "small", color: "secondary", disabled: p.disableClose },
            Preact.h(CloseIcon, { fontSize: "small" }))));
};
Component.displayName = 'BackAndCloseBar';
